export default __webpack_public_path__ + "static/media/full2.1f1286d0.svg";